import React from 'react';
import './App.css';
import UserData from './UserData'; 

function App() {
  return (
    <div>
    <div className="App">
      <UserData />
    </div>
   
    </div>
  );
}

export default App;